import styled from 'styled-components';
import { SectionTitle } from './section-title';

export const SectionImageOuter = styled.div`
  margin-bottom: 4rem;
  align-self: center;
`